import { toast } from "sonner";

export const downloadPdf = async (client, url, filename) => {
  try {
    const { data } = await client.get(url, { responseType: "blob" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 5000);
  } catch {
    toast.error("Could not download PDF");
  }
};
